.dropdown-menu{display:inline;max-height:50vh;overflow:auto!important;padding:5px 0!important;left:auto!important}
/*# sourceMappingURL=column-selector-product-type.component-3TQULSPD.css.map */
